import {
  Box,
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import LOGO from '../../assets/images/logo.svg';
import { numberFormat } from '../../utils/nunberFormat';
import DoneIcon from '@mui/icons-material/Done';
import { DriverFinancialModel } from '../../models/driverFinancial';
import { ArrowBack, Contrast } from '@mui/icons-material';
import { OrderModel } from '../../models/order';
import { convertDateStringToNormalString } from '../../utils/convertDateFormat';
import { CartsModel } from '../../models/carts';
import { useTranslation } from 'react-i18next';
import { EN_ACCEPT_LANGUAGE } from '../../constants/acceptLanguageApi';
import PaidStatusChip from './components/statusPaid';
import useDetailFormDriverFinancialController from './controller/detail';
import { convertOrderStatusCodeToOrderStatusEnum } from '../../utils/convertOrderStatusValue';
import { SECONDARY_COLOR, SELECT_BACKGROUND_COLOR, TEXT_TITLE_COLOR } from '../../constants/colors';
import ConfirmDialog from '../../components/ConfirmDialog';
import { DriverFinancialEnum } from '../../enums/driverFinancailEnum';
import TabRiderDayComponents from './components/tabRiderDay';
import { MonthEnum } from '../../enums/monthEnum';
import { ConvertMonthTypeToNormalString } from '../../utils/convertMonthToNormalString';
import { OrderDriverFinancial } from '../../models/orderDriverFinancial';
import { BalanceModel } from '../../models/balanceModel';
import { DEFAULT_ROWS_PER_PAGE } from '../../config-global';
import { number } from 'yup';
import { IMAGE_SUBMISSION } from '../../lib/endpoints/driverFinancial';
import ConfirmSubmission from './components/confirmSubmission';
import OrderDetailView from './orderDetail';

interface Props {
  onClose: VoidFunction;
  selectedData: DriverFinancialModel
  onFetchData: Function
  financialType: DriverFinancialEnum,
  disableBackButton?: boolean
}

const DetailDriverFinancial = ({ onClose, selectedData, onFetchData, financialType, disableBackButton = false }: Props) => {
  const controller = useDetailFormDriverFinancialController({ selectedData, onClose, onFetchData })
  console.log(selectedData);

  const { t, i18n } = useTranslation("global");

  const TableHeadValues: string[] = [t("paymentMoney_page.No"), t("paymentMoney_page.Image"), t("paymentMoney_page.Total Payment"), t("paymentMoney_page.Confirm By Name"), t("paymentMoney_page.Date")]

  return (
    <>

      {
        controller.openViewOrder ? <OrderDetailView onClose={controller.handleCloseViewOrderDetail} selectedData={selectedData} /> : <Box>
          <IconButton onClick={onClose} sx={{ display: disableBackButton ? "none" : 'block' }}>
            <ArrowBack />
          </IconButton>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }} mb={2}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%', justifyContent: 'space-between' }}>
              <Typography variant="h4" fontWeight='bold' color={TEXT_TITLE_COLOR}>{selectedData?.rider.username} - {selectedData?.rider?.driverNo}</Typography>
              <Typography
                variant="h4"
                fontWeight='bold'
                color={TEXT_TITLE_COLOR}
                sx={{ display: selectedData?.isPaidStatus === true ? '' : 'none' }}
              >
                {t("paymentMoney_page.Total money Rider Got")} : {numberFormat(selectedData?.totalMoneyRiderGot)} {t("Kip")}
              </Typography>
              <Button color='secondary' variant="contained" onClick={() => controller.handleOpenConfirmPayRider()} sx={{ textTransform: 'none', display: selectedData?.isPaidStatus === false ? '' : 'none', color: '#fff' }}>
                <DoneIcon sx={{ color: "#fff" }} />
                &nbsp;&nbsp; {t("paymentMoney_page.Pay Rider")}
              </Button>
            </Box>
          </Box>
          {/* Card Show money rider */}
          <Box sx={{ display: selectedData?.isPaidStatus === true ? 'none' : 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
            <Box sx={{
              height: 160, width: 400, borderRadius: '15px', boxShadow:
                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
              p: 4
            }}>
              <Typography variant="h6" fontWeight='bold' textAlign='center' color={TEXT_TITLE_COLOR}>{t("paymentMoney_page.Total Money Rider Can Take")}</Typography>
              <Box mt={2} sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                <Typography variant='h4' fontWeight='bold' color="red">{numberFormat(selectedData?.rider?.totalMoneyRiderCantake)} {t("Kip")}</Typography>
                <Box mt={1} sx={{ display: 'flex', justifyContent: 'space-between', gap: 4 }}>
                  <Box>
                    <Typography fontWeight='bold' color={TEXT_TITLE_COLOR} sx={{ display: selectedData?.ordersReturn === null ? 'none' : 'block' }}>{t("paymentMoney_page.Total compensation Rider receive")}</Typography>
                    <Typography fontWeight='bold' color={TEXT_TITLE_COLOR} sx={{ display: selectedData?.ordersCash === null ? 'none' : 'block' }} mt={1}>{t("paymentMoney_page.Total Delivery Money")}</Typography>
                  </Box>
                  <Box>
                    <Typography fontWeight='bold' color={TEXT_TITLE_COLOR} sx={{ display: selectedData?.ordersReturn === null ? 'none' : 'block' }}>{numberFormat(selectedData?.rider?.totalMoneyOrderReturn)} {t("Kip")}</Typography>
                    <Typography fontWeight='bold' color={TEXT_TITLE_COLOR} sx={{ display: selectedData?.ordersCash === null ? 'none' : 'block' }} mt={1}>{numberFormat(selectedData?.totalMoneyRiderGot)} {t("Kip")}</Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          {/*  */}
          <Grid container spacing={2} mt={3}>
            {/* <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ background: '#c4eaff', p: 4, borderRadius: "12px" }}>
                <Typography variant='h6' color={TEXT_TITLE_COLOR} fontWeight="bold">{t("paymentMoney_page.Total Money")}</Typography>
                <Typography variant='h6' color={TEXT_TITLE_COLOR} fontWeight="bold">{numberFormat(controller.totalSum)} {t("Kip")}</Typography>
              </Box>
            </Grid> */}
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ background: '#c1fec6', p: 4, borderRadius: "12px" }}>
                <Typography variant='h6' color={TEXT_TITLE_COLOR} fontWeight="bold">{t("paymentMoney_page.Total Money")}</Typography>
                <Typography variant='h6' color={TEXT_TITLE_COLOR} fontWeight="bold">{numberFormat(controller.balanceSubmissionMoney)} {t("Kip")}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ background: '#ffacb6', p: 4, borderRadius: "12px" }}>
                <Typography variant='h6' color={TEXT_TITLE_COLOR} fontWeight="bold">{t("paymentMoney_page.Total OnePay")}</Typography>
                <Typography variant='h6' color={TEXT_TITLE_COLOR} fontWeight="bold">{numberFormat(controller.totalOnePay)} {t("Kip")}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ background: '#f8f8f8', p: 4, borderRadius: "12px" }}>
                <Typography variant='h6' color={TEXT_TITLE_COLOR} fontWeight="bold">{t("clearanceMoney_page.Total Return Order")}</Typography>
                <Typography variant='h6' color={TEXT_TITLE_COLOR} fontWeight="bold">{numberFormat(controller.totalReturnOrder)} {t("Kip")}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ background: '#F1EB90', p: 4, borderRadius: "12px" }}>
                <Typography variant='h6' color={TEXT_TITLE_COLOR} fontWeight="bold">{t("paymentMoney_page.Total Distance Rider")}</Typography>
                <Typography variant='h6' color={TEXT_TITLE_COLOR} fontWeight="bold">{numberFormat(controller.distanceRiderGot)} ກິໂລເເມັດ</Typography>
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', mt: 1 }}>
            <Button variant="outlined" color='secondary' sx={{ textTransform: 'none' }} onClick={controller.handleOpenViewOrderDetail}>
              {t("paymentMoney_page.View All Order")}
            </Button>
          </Box>
          <Box mt={1}>
            <TableContainer>
              <Table>
                <TableHead sx={{ background: '#f7f7f7' }}>
                  <TableRow>
                    {
                      TableHeadValues.map((item: string, ind: number) => <TableCell key={ind} sx={{ borderBottom: 'none' }}>{item}</TableCell>)
                    }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    controller?.rows?.map((item: BalanceModel, index: number) => (
                      <TableRow key={item?.id}>
                        <TableCell align="left" sx={{ borderBottom: 'none' }}>
                          {numberFormat(index + 1 + DEFAULT_ROWS_PER_PAGE * (controller.currentPage - 1))}
                        </TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}>
                          <img src={IMAGE_SUBMISSION + item?.image?.url} alt="" style={{ width: 45, height: 45 }} />
                        </TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}>{numberFormat(item?.totalMoney)} {t("Kip")}</TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}>{item?.confirmByName}</TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}>{convertDateStringToNormalString(item?.createdAt)}</TableCell>
                      </TableRow>
                    ))
                  }
                </TableBody>
              </Table>
            </TableContainer>
            <Divider />
            <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
              <Pagination
                color="primary"
                page={controller.currentPage}
                onChange={controller.handleChangePage}
                count={controller.countPagination}
              />
            </Box>
          </Box>
          <ConfirmDialog
            open={controller.openPayRider}
            title={t('driverFinancial_page.Do you want to Pay this Rider ?')}
            loading={controller.loadingButton}
            onCancel={controller.handleCloseConfirmPayRider}
            onConfirm={() => controller.handleSubmitPayDriver()}
          />
        </Box>
      }

    </>
  );
};
export default DetailDriverFinancial;
